"use strict";

/**
 * Composant _PartialScrollTop.cshtml
 */


const J_SHOW_ON_SCROLL = '.j_showOnScroll'

const element = $(J_SHOW_ON_SCROLL)

// Gestion du click
element.on("click", () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});

// Gestion du scroll
window.addEventListener("scroll", showScrollToTopIcon)


/**
 * Afficher ou cacher l'icone
 */
function showScrollToTopIcon() {
    const duration = 700
    const scrollPosition = $(window).scrollTop()
    const isVisible = element.css('display') === "block"

    // Show icon
    if (scrollPosition > 440 && !isVisible) {
        element.fadeIn(duration)
        $('.j_scroll_tri').addClass('scrolltrimob')
        $('.list-filters').addClass('filters-scroll')
        $('.header-mob').hide()
        $('.btnfiltretri').hide()
        $('.to-top-mobile').css('bottom', '5px')
        return
    }

    // Hide icon
    if (scrollPosition < 440 && isVisible) {
        element.stop().fadeOut(duration)
        $('.j_scroll_tri').removeClass('scrolltrimob')
        $('.list-filters').removeClass('filters-scroll')
        $('.header-mob').show()
    }
}


